export function TabButton({ label, active, count, onClick, accent }) {
  return (
    <button
      onClick={onClick}
      className="relative flex items-center gap-2 px-5 py-3 text-[13px] font-bold transition-all duration-150 border-b-2 focus:outline-none"
      style={{
        borderBottomColor: active ? accent : "transparent",
        color: active ? accent : "#94A3B8",
        background: "transparent",
      }}
    >
      {label}
      {count !== undefined && (
        <span
          className="inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-black"
          style={{
            background: active ? accent : "#F1F5F9",
            color: active ? "#fff" : "#64748B",
          }}
        >
          {count}
        </span>
      )}
    </button>
  );
}